import React, { useContext } from "react";

interface IMarketingToolsIDs {
  pixelId: string | undefined;
  newGoogleAnalyticsId: string | undefined;
  googleAnalyticsId: string | undefined;
  googleTagManager: string | undefined;
  loadedMarketingScripts?: boolean;
}

interface IMarketingContext extends IMarketingToolsIDs {
  trackEvents: (type: Events, fbArgs?: any, analyticsArgs?: any) => void;
  trackPurchase: Function;
}

interface IMarketingContextProps extends IMarketingToolsIDs {
  children: React.ReactNode;
}

export enum Events {
  ADD_TO_CART = "AddToCart",
  INITIATE_CHECKOUT = "InitiateCheckout",
  VIEW_CONTENT = "ViewContent",
  PURCHASE = "Purchase",
}

export const MarketingContext = React.createContext<IMarketingContext | undefined>(undefined);

const MarketingContextProvider = ({
  pixelId,
  newGoogleAnalyticsId,
  googleAnalyticsId,
  googleTagManager,
  children,
  loadedMarketingScripts,
}: IMarketingContextProps) => {
  const trackFacebookEvent = (type: Events, args?: any) => {
    //@ts-ignore
    fbq("track", type, args);
  };

  const trackGoogleAnalyticsEvent = (type: Events, args?: any) => {
    //@ts-ignore
    gtag("event", type, args);
  };

  const trackEvents = (type: Events, fbArgs?: any, analyticsArgs?: any) => {
    if (loadedMarketingScripts) {
      if (pixelId) trackFacebookEvent(type, fbArgs);
      if (googleAnalyticsId) trackGoogleAnalyticsEvent(type, analyticsArgs);
    }
  };

  const trackPurchase = (analyticsArgs?: any) => {
    if (googleAnalyticsId) trackGoogleAnalyticsEvent(Events.PURCHASE, analyticsArgs);
  };

  return (
    <MarketingContext.Provider
      value={{
        pixelId,
        newGoogleAnalyticsId,
        googleAnalyticsId,
        googleTagManager,
        trackEvents,
        loadedMarketingScripts,
        trackPurchase,
      }}>
      {children}
    </MarketingContext.Provider>
  );
};

export const useMarketingContext = () => useContext(MarketingContext);

export default MarketingContextProvider;
